import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var AccountThemedIcon = function AccountThemedIcon(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'onyx' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "AccountThemedIcon",
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    className: classNames('cogs-icon', 'cogs-subapp-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--500)"),
      fillRule: "evenodd",
      d: "M15.249 12.005a6 6 0 1 0-6.612.006A6 6 0 0 0 3 18v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4a6 6 0 0 0-5.751-5.995",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--200)"),
      d: "M5 18a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v5H5z",
      opacity: ".8"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--200)"),
      d: "M3 21h18v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM8 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2z",
      opacity: ".8"
    })]
  }));
};

export { AccountThemedIcon };
